import { Box } from '@mui/material'
import React, { ReactNode } from 'react'
import Header from '../../Header/Header'

interface MainLayoutProps {
  children: ReactNode;
}

function MainLayout({children}:MainLayoutProps) {
  return (
    <Box className='d-flex flex-column w-100'>
      <Box className='position-sticky top-0' sx={{zIndex:3}}>
      <Header/>
      </Box>
      <Box className='flex-1 mt-2' >
      {children}
      </Box>
    </Box>
  )
}

export default MainLayout
